var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetaVoltar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5712 27.1476C45.8275 27.6539 45.7353 28.2669 45.3414 28.6754C44.9475 29.0839 44.3382 29.1983 43.8229 28.9605L37.158 25.8844C31.5564 23.2991 25.4435 22.1164 19.3411 22.3946C19.2686 24.3542 19.1611 26.3128 19.0184 28.2696L18.8359 30.7735C18.7252 32.2925 17.0314 33.1417 15.7479 32.3216C10.1773 28.7621 5.33446 24.1756 1.47761 18.8065L0.250439 17.0982C-0.0834796 16.6333 -0.0834796 16.0072 0.250439 15.5424L1.4776 13.8341C5.33446 8.46498 10.1773 3.87844 15.7479 0.318917C17.0314 -0.501176 18.7252 0.347991 18.8359 1.86705L19.0184 4.37095C19.1409 6.05056 19.2375 7.73159 19.3082 9.41343H21.0231C30.5724 9.41343 39.3103 14.7832 43.6242 23.3025L45.5712 27.1476Z",
    fill: "#2980B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaVoltar);
export default __webpack_public_path__ + "static/media/SetaVoltar.1bcdc139fc5dce5de1a556e691de3cbd.svg";
export { ForwardRef as ReactComponent };